import React from 'react';
import Button from '@latitude/button-rebrand';
import { BREAKPOINT } from '@/utils/constants';
import SvgInline from '@/components/SvgInline/SvgInline';
import CardLabel from '../../CardLabel';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import Typography from '@latitude/typography';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';
import { Link } from '@latitude/link';
import { getCdrEntryBindingRichTextOptions } from '@/utils/contentfulRichTextBindings';
import './_card.scss';

const Card = ({
  location,
  data,
  cardTitleSize,
  cardDescriptionSize,
  theme,
  cardRef,
  cardTitleRef,
  cardBodyRef,
  category,
  action,
  stackedCol,
  cardNumber,
  textColor
}) => {
  const {
    id,
    name,
    image,
    icon,
    labelText,
    labelTheme,
    labelIcon,
    title,
    description,
    buttonTheme,
    button,
    buttonIcon,
    cardUrl
  } = data;
  const TITLE_OPTIONS_H4 = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.SH3
          semibold
          color={
            textColor === 'indigo' ? REBRAND_COLOR.INDIGO : REBRAND_COLOR.BLACK
          }
        >
          {children}
        </Typography.SH3>
      )
    }
  });

  const TITLE_OPTIONS_H5 = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.SH4
          semibold
          color={
            textColor === 'indigo' ? REBRAND_COLOR.INDIGO : REBRAND_COLOR.BLACK
          }
        >
          {children}
        </Typography.SH4>
      )
    }
  });

  const DESCRIPTION_OPTIONS_SUBTITLE = getCdrEntryBindingRichTextOptions({
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.Body
          color={
            textColor === 'indigo'
              ? REBRAND_COLOR.INDIGO
              : REBRAND_COLOR.BLACK_80
          }
        >
          {children}
        </Typography.Body>
      )
    }
  });

  const getButtonType = theme => {
    if (theme === 'Outline') return 'secondary-white';
    else if (theme === 'Blue') return 'secondary-blue';
    return 'primary';
  };
  console.log('tracking', name);
  return (
    <div
      ref={cardRef?.[id]}
      className={`card-wrap card-wrap--${theme?.toLowerCase()}`}
      css={`
        background-color: ${theme?.toLowerCase() === 'white'
          ? REBRAND_COLOR.STONE
          : REBRAND_COLOR.WHITE};
        @media (min-width: ${BREAKPOINT.XL}) {
          width: ${cardNumber <= 3 && '440px'};
        }
        .card-wrapper-description p {
          color: ${textColor === 'indigo'
            ? REBRAND_COLOR.INDIGO
            : REBRAND_COLOR.BLACK} !important;
        }
      `}
    >
      <Link
        href={cardUrl}
        style={{ cursor: cardUrl ? 'pointer' : 'default' }}
        trackEventData={{
          label: button?.text || name,
          location: name,
          category: category,
          action: action
        }}
        target="_self"
      >
        {image && (
          <img
            className={`card-wrapper-image card-wrapper-image--${stackedCol >
              3 ||
              (cardNumber > 3 && 'small')}`}
            src={image?.file?.url}
            alt={image?.description || image?.file?.fileName}
          />
        )}
        <div className="card-wrapper-content">
          {icon && <SvgInline className="card-wrapper-svg-icon" name={icon} />}
          {labelText && (
            <CardLabel
              text={labelText}
              theme={labelTheme}
              icon={labelIcon}
            ></CardLabel>
          )}
          {title && (
            <div ref={cardTitleRef?.[id]} className="card-wrapper-title">
              {documentToReactComponents(
                title,
                cardTitleSize === 'Heading 4'
                  ? TITLE_OPTIONS_H4
                  : TITLE_OPTIONS_H5
              )}
            </div>
          )}
          {description && (
            <div ref={cardBodyRef?.[id]} className="card-wrapper-description">
              {documentToReactComponents(
                description,
                DESCRIPTION_OPTIONS_SUBTITLE
              )}
            </div>
          )}
          {button?.url && (
            <Button
              variant={getButtonType(buttonTheme)}
              size="lg"
              trackEventData={{
                label: button?.text,
                location: name,
                category: category,
                action: action
              }}
              ctaText={button?.text}
              ctaUrl={button?.url}
            />
          )}
        </div>
      </Link>
    </div>
  );
};

export default Card;
